import { useEventRawInterpolationsFetcher } from './event'
import { useFormNonComplianceRawInterpolationsFetcher } from './formNonCompliance'
import { useNonComplianceGroupRawInterpolationsFetcher } from './nonComplianceGroup'
import { useServiceOrderRawInterpolationsFetcher } from './serviceOrder'
import { useServiceOrderNonComplianceRawInterpolationsFetcher } from './serviceOrderNonCompliance'

// Mesmo motivo documentado em interpolations.js: essas duas entidades de tag despacham o registro
// achatado de `service_order` (raiz "service_order", sem aninhamento como em `event`).
const SERVICE_ORDER_SHAPED_ENTITIES = ['service_order', 'service_order_tag_assigned', 'service_order_tag_removed']

// Mesmo motivo documentado em interpolations.js: service_order_reply despacha o registro aninhado
// (`reply.service_order`), igual a `event`, não o achatado de `service_order`.
const EVENT_SHAPED_ENTITIES = ['event', 'service_order_reply']

export const useRawInterpolations = (origin, checklistId) => {
  return [
    ...useServiceOrderRawInterpolationsFetcher(!SERVICE_ORDER_SHAPED_ENTITIES.includes(origin), checklistId),
    ...useServiceOrderNonComplianceRawInterpolationsFetcher(origin !== 'non_compliance_event', checklistId),
    ...useNonComplianceGroupRawInterpolationsFetcher(origin !== 'non_compliance'),
    ...useFormNonComplianceRawInterpolationsFetcher(origin !== 'forms_non_compliance_event'),
    ...useEventRawInterpolationsFetcher(!EVENT_SHAPED_ENTITIES.includes(origin), checklistId, origin)
  ]
}
